import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ModalWrapper from '../group-shopping/components/GroupModal';
import AddressSelect from '../group-shopping/components/CheckoutSearchSelect';

interface OrderUpdateFormValues {
  shipping_name: string;
  shipping_address: string;
  shipping_area_id: string;
  shipping_city_id: string;
  shipping_zone_id: string;
  shipping_phone: string;
}

interface OrderUpdateModalProps {
  show: boolean;
  handleClose: () => void;
  onSubmit: (data: OrderUpdateFormValues) => void;
  initialValues?: Partial<OrderUpdateFormValues>;
}

const OrderUpdateModal: React.FC<OrderUpdateModalProps> = ({
  show,
  handleClose,
  onSubmit,
  initialValues = {},
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm<OrderUpdateFormValues>();

  useEffect(() => {
    if (show) {
      reset(initialValues);
    }
  }, [show, initialValues, reset]);

  return (
    <ModalWrapper
      show={show}
      handleClose={handleClose}
      title="Update Order Shipping Information"
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-12">
          <div className="checkout__details">
            <div className="row g-4">
              {/* Name Field */}
              <div className="col-12">
                <div className="input-group">
                  <input
                    {...register('shipping_name', {
                      required: 'Name is required',
                    })}
                    className="form-control"
                    placeholder="Name*"
                  />
                </div>
                {errors.shipping_name && (
                  <small className="text-danger">
                    {errors.shipping_name.message}
                  </small>
                )}
              </div>

              {/* Phone Field */}
              <div className="col-12">
                <div className="input-group">
                  <input
                    {...register('shipping_phone', {
                      required: 'Phone number is required',
                      pattern: {
                        value: /^01\d{9}$/,
                        message:
                          'Enter a valid 11-digit Bangladeshi phone number',
                      },
                    })}
                    className="form-control"
                    placeholder="Phone*"
                    maxLength={11}
                    inputMode="numeric"
                  />
                </div>
                {errors.shipping_phone && (
                  <small className="text-danger">
                    {errors.shipping_phone.message}
                  </small>
                )}
              </div>

              {/* Address Select (area/city/zone) */}
              <AddressSelect setValue={setValue} watch={watch} />

              {/* Address Field */}
              <div className="col-12">
                <div className="input-group">
                  <input
                    {...register('shipping_address', {
                      required: 'Address is required',
                    })}
                    className="form-control"
                    placeholder="Address"
                  />
                </div>
                {errors.shipping_address && (
                  <small className="text-danger">
                    {errors.shipping_address.message}
                  </small>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            className="trk-btn trk-btn--md trk-btn--outline"
            onClick={handleClose}
            type="button"
          >
            Cancel
          </button>
          <button
            className="trk-btn trk-btn--md trk-btn--primary"
            type="submit"
          >
            Save Changes
          </button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default OrderUpdateModal;
